import React from 'react';

import { useAppSelector } from '../../../../components/hooks';
import { LayoutCoordinateVisuals } from '../../../../library/layout-geometry/LayoutCoordinateVisuals';
import { getActiveFeatureAreaMode } from '../../../../store/selectors/layoutVisualOptionsSelectors';
import { useAutoInvalidateOnChange } from '../../../hooks/invalidation-hooks';
import { useFeatureAreaStyleCalculator } from '../../polygon-rendering/common/style';
import { GenericFeatureAreaVisual } from './GenericFeatureAreaVisual';
import { InsertionFeatureAreaVisual } from './InsertionFeatureAreaVisual';

export function FeatureAreasController() {
  const containers = Object.values(useAppSelector((state) => state.layout.featurePatternContainers));

  const getStyle = useFeatureAreaStyleCalculator();
  const renderMode = useAppSelector(getActiveFeatureAreaMode);

  useAutoInvalidateOnChange(renderMode); // the feature pattern containers controller invalidates on edits

  if (renderMode === 'none') return null;

  return (
    <LayoutCoordinateVisuals>
      <InsertionFeatureAreaVisual />
      {containers.flatMap((container) =>
        container.featureAreas.map((area) => (
          <GenericFeatureAreaVisual key={area.guid} style={getStyle(area)} container={container} area={area} />
        )),
      )}
    </LayoutCoordinateVisuals>
  );
}
